import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';
import { getEscrowStatement } from '../../../API/order/escrow/EscrowAPI';

export const { slice: getEscrowStatementSlice, asyncAction: getEscrowStatementAction } = createKeyedDataAsyncSlice(
  'getEscrowStatementSlice',
  getEscrowStatement,
  (orderId) => orderId
);
